import ObjectCollection from "../prototypes/ObjectCollection";
import MessageModel from "./MessageModel";
import _ from "underscore";

class MessageCollection extends ObjectCollection<MessageModel> {
  name = "MessageCollection";
  route = "apiMessageCollection";
  idAttribute = "id_sushi_message";
  comparator = "priority_with_id"; // basé sur la proprité `priority` et l'id le plus récent
  // attention j'ai fait ce comparator mais juste pour pouvoir jouer avec les id
  initialize(
    models?: Record<string, any>[] | MessageModel[],
    options?: any
  ): void {
    const collection = this;
    super.initialize.apply(collection, [models, options]);
  }
  fetchAndReset() {
    this.fetch({ reset: true });
  }
  getByLocation(location: string, options?: any) {
    // TODO peut-être ajouté des notions de filtre (vu/pas vu) ?
    const collection = this;
    if (location === "shop_info") {
      return collection.find(function (message) {
        return message.validateTime();
      });
    } else {
      return collection.find(function (message) {
        const isMatch = _.isMatch(message.attributes, {
          location: location,
          dismissed: false,
        });
        return isMatch && message.validateTime();
      });
    }
  }
}
MessageCollection.prototype.model = MessageModel;
MessageCollection.prototype.url = () => "/sushimessage/";
export default MessageCollection;
